import React from 'react';
import { StandardDialog } from 'shared-components/components';
import Typography from '@mui/material/Typography';
import { gql, useMutation } from '@apollo/client';

interface DiscardUnApprovedDocsDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  careplanId: string;
}

const AUTODOC_DISCARD_UNAPPROVED_CHANGES = gql`
  mutation DiscardAutoDocAllUnApprovedChanges($careplanId: ID!) {
    discardAutoDocAllUnApprovedChanges(careplanId: $careplanId) {
      success
    }
  }
`;

const DiscardUnApprovedDocsDialog = ({
  open,
  onClose,
  onSubmit,
  careplanId,
}: DiscardUnApprovedDocsDialogProps): JSX.Element => {
  const [discardAutoDocAllUnApprovedChanges] = useMutation(AUTODOC_DISCARD_UNAPPROVED_CHANGES);
  const handleOnSubmit = () => {
    discardAutoDocAllUnApprovedChanges({ variables: { careplanId } }).then(() => {
      onSubmit();
      onClose();
    });
  };

  return (
    <StandardDialog
      title="Discard current changes?"
      open={open}
      onClose={onClose}
      onSubmit={handleOnSubmit}
      submitText="continue"
      closeText="Cancel">
      <Typography paddingY={1}>Any unapproved changes in the current version will be discarded. </Typography>
    </StandardDialog>
  );
};

export default DiscardUnApprovedDocsDialog;
